<template>
  <b-modal
    v-if="test"
    v-model="show"
    size="lg"
    ok-title="Kaydet"
    cancel-title="Vazgeç"
    :ok-disabled="isLoading"

    :title="test.question"
    @ok="type === 'create' ? createTest($event) : updateTest($event)"
  >
    <Loader
      v-if="isLoading"
      style="opacity: 0.5"
    />
    <b-form-group>
      <label>question</label>
      <input
        v-model="test.question"
        type="text"
        class="form-control"
        placeholder="question"
      >
    </b-form-group>
    <b-form-group>
      <label>questionImage</label>
      <b-row>
        <b-col
          v-if="isQuestionImageActive"

          md="12"
          :class="test.questionImage ? 'mb-3' : ''"
        >
          <b-form-file
            id="questionImage"
            placeholder="Soru görseli seçin..."
            accept="image/*"

            @change="convertImageToBase64"
          />
        </b-col>
        <b-col
          v-if="test.questionImage"
          md="4"
        >
          <p
            v-if="!isQuestionImageActive"
            class="text-primary"
            @click.stop="isQuestionImageActive = true"
          >
            <u style="cursor: pointer">
              <small>
                Yeni görsel seç
              </small>
            </u>
          </p>
          <img
            :src="test.questionImage"
            width="220"
          >
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <label>answerOneDesc</label>
      <input
        v-model="test.answerOneDesc"
        type="text"
        class="form-control"
        placeholder="answerOneDesc"
      >
    </b-form-group>
    <b-form-group>
      <label>answerOneImg</label>
      <b-row>
        <b-col
          v-if="isAnswerOneImgActive"

          md="12"
          :class="test.answerOneImg ? 'mb-3' : ''"
        >
          <b-form-file
            id="answerOneImg"
            placeholder="Cevap 1 görseli seçin..."
            accept="image/*"

            @change="convertImageToBase64"
          />
        </b-col>
        <b-col
          v-if="test.answerOneImg"
          md="4"
        >
          <p
            v-if="!isAnswerOneImgActive"
            class="text-primary"
            @click.stop="isAnswerOneImgActive = true"
          >
            <u style="cursor: pointer">
              <small>
                Yeni görsel seç
              </small>
            </u>
          </p>
          <img
            :src="test.answerOneImg"
            width="220"
          >
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <label>answerTwoDesc</label>
      <input
        v-model="test.answerTwoDesc"
        type="text"
        class="form-control"
        placeholder="answerTwoDesc"
      >
    </b-form-group>
    <b-form-group>
      <label>answerTwoImg</label>
      <b-row>
        <b-col
          v-if="isAnswerTwoImgActive"

          md="12"
          :class="test.answerTwoImg ? 'mb-3' : ''"
        >
          <b-form-file
            id="answerTwoImg"
            placeholder="Cevap 2 görseli seçin..."
            accept="image/*"

            @change="convertImageToBase64"
          />
        </b-col>
        <b-col
          v-if="test.answerTwoImg"
          md="4"
        >
          <p
            v-if="!isAnswerTwoImgActive"
            class="text-primary"
            @click.stop="isAnswerTwoImgActive = true"
          >
            <u style="cursor: pointer">
              <small>
                Yeni görsel seç
              </small>
            </u>
          </p>
          <img
            :src="test.answerTwoImg"
            width="220"
          >
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group>
      <label>typeForm</label>
      <b-form-select
        v-model="test.typeForm"
        :options="typeforms"
        text-field="name"
        value-field="_id"
      />
    </b-form-group>
    <b-form-group>
      <label>language</label>
      <b-form-select
        v-model="test.language"
        :options="languages"
        text-field="name"
        value-field="_id"
      />
    </b-form-group>
    <b-form-group>
      <input
        id="popular"
        v-model="test.popular"

        type="checkbox"
      >
      <label
        class="ml-2"
        for="popular"
      >
        Popular
      </label>
    </b-form-group>
    <b-form-group>
      <input
        id="isActive"
        v-model="test.isActive"

        type="checkbox"
      >
      <label
        class="ml-2"
        for="isActive"
      >
        isActive
      </label>
    </b-form-group>
  </b-modal>
</template>
<script>
import Loader from '@/components/Loader';

import { API } from '@/services/';
import {
  API_GET_LANGUAGES, API_GET_TYPEFORMS, API_CREATE_NEW_TEST, API_UPDATE_TEST_BY_ID,
} from '@/helpers/config';

export default {
  components: {
    Loader,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'create',
      validator: value => ['create', 'update'].indexOf(value) !== -1
      ,
    },
    data: {
      type: Object,
      default: () => {},
      required: value => value === 'update',
    },
  },
  data: () => ({
    // it is used for avoiding direct prop mutation
    show: false,
    test: null,
    languages: [],
    typeforms: [],
    isQuestionImageActive: false,
    isAnswerOneImgActive: false,
    isAnswerTwoImgActive: false,
    isLoading: false,
  }),
  watch: {
    // when v-model is changed in parent, update show value
    value(val) {
      this.show = val;
    },
    // when show value is updated, emit new value to parent (v-model)
    show(val) {
      this.$emit('input', val);

      // if modal will be visible
      if (val) this.resetModalData();
    },
  },
  created() {
    this.show = this.value;
    this.getDropdownData();
  },
  methods: {
    resetModalData() {
      if (this.type === 'create') {
        this.test = {
          question: null,
          questionImage: null,
          answerOneDesc: null,
          answerOneImg: null,
          answerTwoDesc: null,
          answerTwoImg: null,
          typeForm: null,
          language: null,
          isActive: true,
          popular: false,
        };

        this.isQuestionImageActive = true;
        this.isAnswerOneImgActive = true;
        this.isAnswerTwoImgActive = true;
      } else if (this.type === 'update') {
        this.test = JSON.parse(JSON.stringify(this.data));
        delete this.test._id;
        delete this.test.created;
        delete this.test.__v;
        delete this.test.typeFormName;
        delete this.test.languageName;

        this.test.typeForm = this.test.typeForm._id;
        this.test.language = this.test.language._id;

        this.isQuestionImageActive = false;
        this.isAnswerOneImgActive = false;
        this.isAnswerTwoImgActive = false;
      }
    },
    convertImageToBase64(event) {
      const self = this;
      // get image field from id
      const imageField = event.target.id;
      // init file reader
      const reader = new FileReader();
      // read base64 image
      reader.readAsDataURL(event.target.files[0]);
      // load base64 image
      // eslint-disable-next-line
      reader.onload = function () {
        // set base64 image to imageField. -> exm. this[questionImage]
        self.test[imageField] = reader.result;
      };
      // eslint-disable-next-line
      reader.onerror = function (error) {
        // eslint-disable-next-line
        console.log('Error: ', error);
      };
    },
    getLanguages() {
      return API
        .get(API_GET_LANGUAGES);
    },
    getTypeforms() {
      return API
        .get(API_GET_TYPEFORMS);
    },
    getDropdownData() {
      const promises = [];

      promises.push(this.getLanguages());
      promises.push(this.getTypeforms());

      Promise.all(promises).then((results) => {
        this.languages = results[0].data;
        this.typeforms = results[1].data;
      });
    },
    createTest(e) {
      e.preventDefault();
      this.isLoading = true;

      API
        .post(API_CREATE_NEW_TEST, this.test)
        .then((response) => {
          this.$snotify.success(response.data.message);
          this.isLoading = false;
          this.show = false;
        })
        .catch((error) => {
          this.$snotify.error(error.response.data.message);
          this.isLoading = false;
        });
    },
    updateTest(e) {
      e.preventDefault();
      this.isLoading = true;

      const imgRegex = /tests%2F.*\.png/gm;
      // if image field has a url value, that means new image is not selected
      // if new image is not selected, remove it from update object
      // because update endpoint accepts only base64 strings
      if (this.test.questionImage.match(imgRegex)) delete this.test.questionImage;
      if (this.test.answerOneImg.match(imgRegex)) delete this.test.answerOneImg;
      if (this.test.answerTwoImg.match(imgRegex)) delete this.test.answerTwoImg;

      API
        .put(API_UPDATE_TEST_BY_ID + this.data._id, this.test)
        .then((response) => {
          this.$snotify.success(response.data.message);
          this.isLoading = false;
          this.show = false;
        })
        .catch((error) => {
          this.$snotify.error(error.response.data.message);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped>

</style>
